

// var urls = function(){
//   var REBATE_INIT = "ac=init";
// }

// export default {    
//   istest(){
//       console.log("this is test")
//   },
//   init(){
//     return "ac=init";
//   }
// }

var urls = {
  // REBATE_INIT: 'rebate/cross_index.php?ct=rebate&ac=init',// 红包初始化
  // REBATE_USER: 'rebate/cross_index.php?ct=rebate&ac=user',// 红包用户信息
  // REBATE_SHOW: 'rebate/cross_index.php?ct=rebate&ac=show',// 获取红包数据
  // REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebate&ac=receive',// 领取红包
  // REBATE_RECEIVE_LOG: 'rebate/cross_index.php?ct=rebate&ac=receiveLog',// 红包领取记录
  // REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebate&ac=wxAuth',// 微信绑定二维码
  // REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebate&ac=exchangeLog',// 兑换日志
  // REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebate&ac=exchangeWx',// 兑换
  // REBATE_EDITPASSWORD: 'common/cross_index.php?ct=user&ac=editPassword',// 修改密码
  // REBATE_SEND: 'common/cross_index.php?ct=sms&ac=send',// 获取验证码
  
  USER_INFO: 'common/cross_index.php?ct=user&ac=info',// 用户信息接口

  GET_PROTOCOL: 'common/cross_index.php?ct=info&ac=protocol',// 获取协议接口
  GET_POLICY: 'common/cross_index.php?ct=info&ac=policy',// 获取隐私政策接口
  SEND_CODE: 'common/cross_index.php?ct=sms&ac=send',// 发送验证码接口
  PHONE_CODE_LOGIN: 'common/cross_index.php?ct=user&ac=freeLogin',// 手机验证码登录
  ACCOUNT_PASSWORD_LOGIN: 'common/cross_index.php?ct=user&ac=login',// 账号登录接口  
  ACCOUNT_REGISTER: 'common/cross_index.php?ct=user&ac=register',// 账号注册接口   
  TOKEN_LOGIN: 'common/cross_index.php?ct=user&ac=tokenLogin',// TOKEN登录接口   
  REAL_NAME_STATE: 'common/cross_index.php?ct=user&ac=realNameState',// 实名状态接口
  REAL_NAME: 'common/cross_index.php?ct=user&ac=realName',// 实名接口
  BIND_PHONE: 'common/cross_index.php?ct=user&ac=bind',//绑定手机接口
  EDIT_PASSWORD: 'common/cross_index.php?ct=user&ac=editPassword',//手机验证码修改密码接口
  PAY_DETAIL: 'common/cross_index.php?ct=user&ac=detail',//用户充值信息接口
  CUSTOMER_SERVICE: 'common/cross_index.php?ct=info&ac=customerService',//客服接口
  // BIND_PHONE: 'common/cross_index.php?ct=user&ac=bind',//绑定手机接口
  
}
// var urls_v2 = {
//   REBATE_INIT: 'rebate/cross_index.php?ct=rebate&ac=init',// 红包初始化
//   REBATE_USER: 'rebate/cross_index.php?ct=rebate&ac=user',// 红包用户信息
//   REBATE_SHOW: 'rebate/cross_index.php?ct=rebate&ac=show',// 获取红包数据
//   REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebate&ac=receive',// 领取红包
//   REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebate&ac=wxAuth',// 微信绑定二维码
//   REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebate&ac=exchangeLog',// 兑换日志
//   REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebate&ac=exchange',// 兑换
// }
export default urls


// WEBPACK FOOTER //
// ./src/normal/network/urls.js